import { PrimaryButton } from '@systemeio/ui';
import { usePaypalRestApi } from 'modules/profile/payment-gateways/integrations/paypal-rest/hooks';
import { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
const PaypalRestConnectButton = () => {
  const {
    t
  } = useLocoTranslation();
  const [isFetching, setIsFetching] = useState(false);
  const {
    connect
  } = usePaypalRestApi();
  const handleConnectClick = async () => {
    try {
      setIsFetching(true);
      const currentUrl = window.location.href;
      const response = await connect(currentUrl + '/paypal');
      response.redirectUrl && window.location.replace(response.redirectUrl);
    } catch (e) {
      setIsFetching(false);
    }
  };
  return <PrimaryButton isFetching={isFetching} onClick={handleConnectClick} className={'font-bold'}>
      {t('dashboard.settings.payment_gateways.connect')}
    </PrimaryButton>;
};
export default PaypalRestConnectButton;